// extracted by mini-css-extract-plugin
export default {"home":"Home_home__uEIM2","tagContainer":"Home_tagContainer__RWeLW"};